






































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/PreparacionEquipos/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/PreparacionEquipos/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/PreparacionEquipos/ModalAsignacion.vue';
import { utils, writeFileXLSX } from 'xlsx';
import config from '@/config/index';

import { Funcionalidades } from '@/config/funcionalidades';
import { actionsEvent } from '@/setup';
import {
  GetQuickFilterTextParams,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
  ValueFormatterParams,
  ColDef,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment, { Moment } from 'moment';
import { fetchMS } from '@/pantallas/Conecta/PreparacionEquipos/fetchMS';

import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import ModalEditSeriado from './SeriadoActions/ModalEditSeriado.vue';
import readXlsFile from 'read-excel-file';

const { AgGridVue } = require('ag-grid-vue');

import ModalDevolverSeriado from './SeriadoActions/ModalDevolverSeriado.vue';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    FormFieldsContainer,
    DatePicker,
    ModalEditSeriado,
    ModalDevolverSeriado,
  },
})
export default class AsignacionSeriado extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.PreparacionEquiposSeriados;

  @Prop({
    required: true,
    default: {
      asignumero: '',
      modalidad: '',
      estado: '',
      modalidadid: '',
      asigcreacion_auto: '',
      asigrequerimiento: '',
    },
  })
  regSeleccionado: any;

  readonly loadingService = new LoadingService();
  verfechabateria: boolean = false;
  verfechaplataforma: boolean = false;
  pagina: number = 1;
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  filtrobusquedagrilla: string = '';
  listaReq: any[] = [];
  listaEquipos: any[] = [];
  id_editar: string = '';
  editandoando: boolean = false;
  disabledFieldSerie: boolean = false;
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  showModalNew: boolean = false;
  showModalAsignacion: boolean = false;
  showForm: boolean = false;
  isEdit: boolean = false;
  listaAVL: any[] = [];
  listaModalidad: any[] = [];
  listaEstadoSim: any[] = [];
  deshabilitar: boolean = false;
  btnDisabled: boolean = false;
  data: any = {};
  dialogEditSeriado: boolean = false;
  dialogDevolverSeriado: boolean = false;
  fileName: any = '';
  archivoB64: any = '';
  itemsDelExcel: Array<any> = [];
  errorArchivo: boolean = true;
  errorArchivoModal: boolean = false;

  exportar() {
    //return this.descargarPlantilla('ALL');
    /*let totalFilas = this.gridApi.paginationGetRowCount();
    if (totalFilas > 0) {
      config.crearArchivoCsv(
        'DetalleEquipoSeriados' + '.csv',
        this.ordesList,
        this.columnDefs
      );
      this.$snotify.success(this.$t('mensajes.mensajesExito.exportar'));
    } else {
      this.$snotify.warning('No existen datos para exportar.');
    }*/
  }

  formFields: any = {
    serienumero: {
      label: 'Serie Número',
      id: 'serienumero',
      value: '',
    },
    tipoeqid: {
      label: 'Tipo Equipo',
      id: 'tipoeqid',
      value: '',
    },
    bateria: {
      label: 'Cambio Batería',
      id: '',
      value: '',
    },
    plataforma_ingresada: {
      label: 'Registrado en Plataforma',
      id: '',
      value: '',
    },
    fecha_bateria: {
      label: 'Fecha De Cambio Batería',
      id: '',
      value: '',
    },
    fecha_plataforma: {
      label: 'Fecha en plataforma',
      id: '',
      value: '',
    },
    activacion: {
      label: 'Activación',
      id: 'activacion',
      value: '',
    },
    serieactivafecha_alta: {
      label: 'Fecha Preparación',
      id: '',
      value: moment(),
    },
    serieactivamodalidad: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    serieactivaplataforma: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    modem: {
      label: 'ID en Plataforma',
      id: '',
      value: '',
    },
    serieactivaavl: {
      label: 'AVL',
      id: 'serieactivaavl',
      value: '',
    },
    epc: {
      label: 'EPC',
      id: 'epc',
      value: '',
    },
    simserienumero: {
      label: 'SIM Número',
      id: 'simserienumero',
      value: '',
    },
    estado: {
      label: 'Estado de SIM',
      id: 'estado',
      value: '',
    },
    serieactivaobs: {
      label: 'Observación',
      id: '',
      value: '',
    },
    validauser: {
      label: 'Registro Validado',
      id: '',
      value: false,
    },
  };

  gridOptions: GridOptions;

  /* gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Estado Finalización',
        field: 'serieactiva_finalizada',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEstadoFinalizacion,
      },
      {
        headerName: 'Estado Preparación',
        field: 'validauser',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlestadopreparacion,
      },
      {
        headerName: 'Serie Nro',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeq',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Tipo Equipo ID',
        field: 'tipoeqid',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        hide: true,
      },
      {
        headerName: 'Fecha Preparación',
        field: 'serieactivafecha_alta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD HH:mm:ss'),
      },
      {
        headerName: 'SIM Número',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Modalidad',
        field: 'modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Estado Plataforma',
        field: 'serieactivaplata_ingresada',
        cellStyle: { textAlign: 'left' },
        width: 150,
        cellRenderer: params => {
          if (!params.value) return 'ERROR';
          if (params.data.serieactivaplata_ingresada == 'S') {
            return '<input type="checkbox" checked disabled>';
          }
          return '<input type="checkbox" disabled>';
        },
      },
      {
        headerName: 'Fecha Plataforma',
        field: 'serieactivaplata_fecha',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD HH:mm:ss'),
      },
      {
        headerName: 'ID Plataforma',
        field: 'serieactivaid_dispositivo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'AVL',
        field: 'serieactivaavl',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'EPC',
        field: 'epc',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Observación',
        field: 'serieactivaobs',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Movimiento INET',
        field: 'asiginet_movimiento_nro',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Estado Inventario',
        field: 'estado_inventario',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEtadoInventario,
      },
      {
        headerName: 'Estado Devolución',
        field: 'serieactiva_novalido',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEstadoDevolucion,
      },
    ],
    pagination: true,
    paginationAutoPageSize: false,
    serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
    processCellForClipboard: ({ value }) =>
      value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value,
  }; */
  bloquear_formulario: boolean = false;
  verificacion_bateria: any;
  bloquear_equipos: boolean = false;
  id_usuario: any;
  plataforma: any;
  equipo: any;
  modalidad: any;
  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };
  accionEditarApn: PermisoAccion = {
    accionCodigo: 97,
    visible: false,
  };
  accionElimnarApn: PermisoAccion = {
    accionCodigo: 96,
    visible: false,
  };
  accionDevelverSeriado: PermisoAccion = {
    accionCodigo: 129,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionEditarApn,
    this.accionElimnarApn,
    this.accionCrear,
    this.accionDevelverSeriado,
  ];
  id_eliminar: any;
  asignacion_numero: any;
  serieactivanro: any;

  actions() {
    actionsEvent.onEditarApn(this.handleEditarClick);
    actionsEvent.onEliminarApn(this.handleEliminarClick);
    actionsEvent.onDevolverSeriado(this.handleDevolverSeriadoClick);
  }
  columnDefs: Array<ColDef> = [];
  ordesList: any[] = [];

  constructor() {
    super();
    this.actions();

    this.columnDefs = [
      {
        headerName: 'Estado Finalización',
        field: 'serieactiva_finalizada',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEstadoFinalizacion,
      },
      {
        headerName: 'Estado Preparación',
        field: 'validauser',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlestadopreparacion,
      },
      {
        headerName: 'RUT Cliente',
        field: 'rut_cliente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Serie Nro',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Serie IMEI',
        field: 'serieimei',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'SIM Número',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeq',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Tipo Equipo ID',
        field: 'tipoeqid',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        hide: true,
      },
      {
        headerName: 'Fecha Preparación',
        field: 'serieactivafecha_alta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD HH:mm:ss'),
      },
      {
        headerName: 'Modalidad',
        field: 'modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Producto Comercial',
        field: 'producto_comercial',
        cellStyle: { textAlign: 'left' },
        width: 150,
      },
      {
        headerName: 'Estado Plataforma',
        field: 'serieactivaplata_ingresada',
        cellStyle: { textAlign: 'left' },
        width: 150,
        cellRenderer: params => {
          if (!params.value) return 'ERROR';
          if (params.data.serieactivaplata_ingresada == 'S') {
            return '<input type="checkbox" checked disabled>';
          }
          return '<input type="checkbox" disabled>';
        },
      },
      {
        headerName: 'Fecha Plataforma',
        field: 'serieactivaplata_fecha',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        valueFormatter: params =>
          params.value && moment(params.value).format('YYYY/MM/DD HH:mm:ss'),
      },
      {
        headerName: 'ID Plataforma',
        field: 'serieactivaid_dispositivo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'AVL',
        field: 'serieactivaavl',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'EPC',
        field: 'epc',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Fecha Cambio Batería',
        field: 'fecha_bateria',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Observación',
        field: 'serieactivaobs',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Movimiento INET',
        field: 'asiginet_movimiento_nro',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Estado Inventario',
        field: 'estado_inventario',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEtadoInventario,
      },
      {
        headerName: 'Estado Devolución',
        field: 'serieactiva_novalido',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        cellRenderer: this.getHtmlEstadoDevolucion,
      },
      {
        headerName: 'Glosa CRM',
        field: 'glosa_crm',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 200,
      },
    ];
    this.gridOptions = {
      pagination: true,
      paginationPageSize: 50,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  get fechaMaximaInicio() {
    return moment(this.fechaMaxima) as moment.Moment;
  }

  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    return moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
  }

  @Watch('regSeleccionado')
  onPropertyChanged(value: string, oldValue: string) {
    this.handleVolverClick();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.ordesList = (await this.getAsignacionSeriado()) || [];
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');

    // Agregar el listener para el evento de cambio de datos
    /* this.serverSide = {
      getRows(event: any): void {
         event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = event.request.startRow / self.cant_regs_pag + 1; 
        let body: any = {}; 
        body.pagina = self.pagina;
        body.hashpaginacion = self.hashpaginacion; 
        body.asignumero = self.regSeleccionado.asignumero;
        self.loadingService.showLoading(undefined, 'grillaSeriado');

        fetchMS({ ...body }, 'get_asignacion_seriado_detalle')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '2') {
              event.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.LISTA.length === 0) {
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                event.successCallback(
                  response.data.data.LISTA,
                  response.data.data.TOTAL_REGISTROS
                );
               
                self.gridApi.hideOverlay();
              }
            } else {
              event.successCallback([{}], 0);
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading('grillaSeriado');
          });
      },
    }; */
    /*     this.gridApi.setServerSideDatasource(this.serverSide);
     */
  }

  getAsignacionSeriado() {
    let self = this;
    let body: any = {};
    body.asignumero = self.regSeleccionado.asignumero;
    self.loadingService.showLoading(undefined, 'grillaSeriado');
    return fetchMS({ ...body }, 'get_asignacion_seriado_detalle')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '2') {
          self.gridApi.showNoRowsOverlay();
          return;
        }
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.LISTA.length === 0) {
            self.gridApi.showNoRowsOverlay();
          } else {
            self.gridApi.hideOverlay();
            return response.data.data.LISTA;
          }
        } else {
          self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        self.gridApi.setDomLayout('autoHeight');
        self.loadingService.hideLoading('grillaSeriado');
      });
  }

  handleCierreModalCrear() {
    this.showModalNew = false;
  }

  handleCierreModalAsignacion() {
    this.showModalAsignacion = false;
  }

  filtroAlertas(loadWidget: boolean) {
    /*this.gridApi.setServerSideDatasource(this.serverSide);*/
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async deleteRegistro(
    id_eliminar: string,
    asignacion_numero: string,
    estado_preparacion: string,
    serieactiva_finalizada: string,
    serienumero: string,
    tipoeqid: string,
    asigcreacion_auto: string,
    asigrequerimiento: string
  ) {
    this.loadingService.showLoading(undefined, 'deleteAsignacionSeriado');
    let self = this;
    this.id_usuario = JSON.parse(window.localStorage.user).id;

    let body: any = {
      id: id_eliminar,
      asignumero: asignacion_numero,
      id_usuario: this.id_usuario,
      modulo: this.funcionalidad,
      estado_preparacion,
      serieactiva_finalizada,
      serienumero,
      tipoeqid,
      asigcreacion_auto,
      asigrequerimiento,
    };

    return fetchMS(body, 'deleteAsignacionSeriado')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los equipos',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los eqipos',
            { timeout: 3000 }
          );
        }
      })
      .finally(() =>
        self.loadingService.hideLoading('deleteAsignacionNoSeriado')
      );
  }

  inputValues() {
    const userId: string = JSON.parse(window.localStorage.user).id;
    this.modalidad = this.formFields.serieactivamodalidad.value;
    this.equipo = this.formFields.tipoeqid.value;
    this.plataforma = this.formFields.serieactivaplataforma.value;
    const body: {
      serienumero: string;
      asignumero: string;
      epc: string;
      id_editar: string;
      id_usuario: string;
      modulo: Funcionalidades | string;
      serieactivafecha_alta: moment.Moment | string;
      serieactivamodalidad: string;
      serieactivaobs: string;
      serieactivaplataforma: string;
      tipoeqid: string;

      bateria: string;
      fecha_bateria: moment.Moment | string;
      serieactivaplata_ingresada: string;
      serieactivaplata_fecha: moment.Moment | string;
      modem: string;
      serieactivaavl: string;
      simserienumero: string;
      estado: string;
      serieactivanro: string;
      id_cliente: string;
      validauser: string;
    } = {
      serienumero: this.formFields.serienumero.value || '',
      asignumero: this.regSeleccionado.asignumero || '',
      epc: this.formFields.epc.value || '',
      id_editar: this.id_editar || '',
      id_usuario: userId || '',
      modulo: this.funcionalidad || '',
      serieactivafecha_alta:
        (this.formFields.serieactivafecha_alta.value as moment.Moment) || '',
      serieactivamodalidad: this.modalidad.id || '',
      serieactivaobs: this.formFields.serieactivaobs.value || '',
      serieactivaplataforma: this.plataforma.id || '',
      tipoeqid: this.equipo.id || '',

      bateria: this.formFields.bateria.value || '',
      fecha_bateria:
        (this.formFields.fecha_bateria.value as moment.Moment) || '',
      serieactivaplata_ingresada:
        this.formFields.plataforma_ingresada.value || '',
      serieactivaplata_fecha:
        (this.formFields.fecha_plataforma.value as moment.Moment) || '',
      modem: this.formFields.modem.value || '',
      serieactivaavl: this.formFields.serieactivaavl.value || '',
      simserienumero: this.formFields.simserienumero.value || '',
      estado: this.formFields.estado.value || '',
      serieactivanro: this.serieactivanro || '',
      id_cliente: this.getCliente() || '',
      validauser: this.formFields.validauser.value || '',
    };
    return body;
  }

  async handleGuardarClick() {
    this.loadingService.showLoading(undefined, 'agregarSeriado');
    const body = this.inputValues();
    let self = this;
    return fetchMS({ ...body }, 'agregarSeriado')
      .then(resp => {
        if (resp.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          self.handleVolverClick();
          self.loadingService.hideLoading('agregarSeriado');
          this.editandoando = false;
        } else {
          self.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          self.loadingService.hideLoading('agregarSeriado');
        }
      })
      .catch(error => {
        if (error.message == 'Network Error') {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
          self.loadingService.hideLoading('agregarSeriado');
        } else if (error.response.status != 404) {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
          self.loadingService.hideLoading('agregarSeriado');
        }
      })
      .finally(() => {
        self.loadingService.hideLoading('agregarSeriado');
      });
  }

  handleVolverClick() {
    this.disabledFieldSerie = false;
    this.bloquear_formulario = false;
    this.editandoando = false;
    this.showForm = false;
    this.formFields.serienumero.value = '';
    this.formFields.tipoeqid.value = '';
    this.formFields.bateria.value = '';
    this.formFields.plataforma_ingresada.value = false;
    this.formFields.modem.value = '';
    this.formFields.serieactivaavl.value = '';
    this.verfechaplataforma = false;
    this.verfechabateria = false;
    this.hashpaginacion = '';
    this.formFields.fecha_bateria.value = '';
    this.formFields.serieactivafecha_alta.value = moment();
    this.formFields.serieactivamodalidad.value = {
      nombre: this.regSeleccionado.modalidad,
      id: this.regSeleccionado.modalidadid,
    };
    this.formFields.serieactivaplataforma.value = {
      id: '',
      nombre: '',
    };
    this.formFields.serieactivaavl.value = '';
    this.formFields.simserienumero.value = '';
    this.formFields.estado.value = '';
    this.formFields.epc.value = '';
  }

  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  async handleEliminarClick(params: ICellRendererParams) {
    if (
      params.data.estado_preparacion === 't' &&
      params.data.serieactiva_finalizada === 'Finalizado'
    ) {
      this.$snotify.error(
        `La serie Nro ${params.data.serienumero} no se puede eliminar porque ya se se encuentra finalizada`,
        { timeout: 3000 }
      );
      return;
    }

    this.id_eliminar = params.data.id;
    this.asignacion_numero = params.data.asignumero;

    let resp: any =
      (await this.deleteRegistro(
        this.id_eliminar,
        this.asignacion_numero,
        params.data.estado_preparacion,
        params.data.serieactiva_finalizada,
        params.data.serienumero,
        params.data.tipoeqid,
        this.regSeleccionado.asigcreacion_auto,
        this.regSeleccionado.asigrequerimiento
      )) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.hashpaginacion = '';
      /*       this.gridApi.setServerSideDatasource(this.serverSide);*/
      this.$snotify.success(resp.data.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      if (resp.data.ESTADO == '3') {
        this.handleCerrar();
      }
    }
  }

  handleDevolverSeriadoClick(params: ICellRendererParams) {
    if (
      params.data.serieactiva_novalido === 't' ||
      params.data.serieactiva_finalizada === 'Finalizado'
    ) {
      this.$snotify.warning(
        `La serie Nro ${params.data.serienumero} se encuentra devuelta o finalizada, por ello no se puede devolver`,
        { timeout: 3000 }
      );
    }
    this.data = { ...params.data };
    this.showForm = true;
    this.dialogDevolverSeriado = true;
  }

  handleCerrar() {
    this.$emit('handleCerrar');
  }

  closeModalSeriado(reloadGrid: boolean = false) {
    this.showForm = false;
    this.dialogEditSeriado = false;
    this.dialogDevolverSeriado = false;
    this.data = {};
    if (reloadGrid) {
      this.reloadGrid();
      //this.preLoadExcel();
      /* this.gridApi.setServerSideDatasource(this.serverSide); */
    }
  }

  handleCrearClick() {
    this.data = {
      asignumero: this.regSeleccionado.asignumero,
      asigrequerimiento: this.regSeleccionado.asigrequerimiento,
    };
    this.showForm = true;
    this.id_editar = '';
    this.isEdit = false;
    this.dialogEditSeriado = true;
  }

  handleEditarClick(params: ICellRendererParams) {
    if (
      params.data.serieactiva_novalido === 't' ||
      params.data.serieactiva_finalizada === 'Finalizado'
    ) {
      this.$snotify.warning(
        `La serie Nro ${params.data.serienumero} se encuentra devuelta o finalizada, por ello no se puede editar`,
        { timeout: 3000 }
      );
    }
    this.data = { ...params.data };
    this.data.asignumero = this.regSeleccionado.asignumero;
    this.data.asigcreacion_auto = this.regSeleccionado.asigcreacion_auto;
    this.isEdit = true;
    this.showForm = true;
    this.dialogEditSeriado = true;
  }

  async handleEditarSerie() {
    this.loadingService.showLoading();
    const body = this.inputValues();
    let self = this;
    return fetchMS(body, 'editarSeriado')
      .then(resp => {
        if (resp.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          self.handleVolverClick();
          this.editandoando = false;
        } else {
          self.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          self.loadingService.hideLoading();
        }
        self.loadingService.hideLoading();
      })
      .catch(error => {
        if (error.message == 'Network Error') {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        } else if (error.response.status != 404) {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        }
        self.loadingService.hideLoading();
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  handleBateriaSelected() {
    if (this.formFields.bateria.value) {
      this.verfechabateria = true;
      this.formFields.fecha_bateria.value = moment();
    } else {
      this.verfechabateria = false;
      this.formFields.fecha_bateria.value = '';
    }
  }

  handleFechaPlataforma() {
    if (this.formFields.plataforma_ingresada.value) {
      this.verfechaplataforma = true;
      this.formFields.fecha_plataforma.value = moment();
    } else {
      this.verfechaplataforma = false;
      this.formFields.fecha_plataforma.value = '';
    }
  }

  mounted() {
    this.copy_scroll();
    if (
      this.regSeleccionado != null &&
      ['Finalizado', 'Anulado'].includes(this.regSeleccionado.estado)
    ) {
      this.deshabilitar = true;
      this.$snotify.warning(
        'El requerimiento ya se encuentra finalizado o anulado y no se puede Editar',
        { timeout: 3000 }
      );
    }

    this.formFields.serieactivaplataforma.value = {
      id: '',
      nombre: '',
    };
    // this.getAVL();
    // this.getModalidad();
    this.formFields.serieactivamodalidad.value = {
      nombre: this.regSeleccionado.modalidad,
      id: this.regSeleccionado.modalidadid,
    };
    this.preLoadExcel();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }

    /*     this.gridApi.setServerSideDatasource(this.serverSide);
     */
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  getHtmlEstadoFinalizacion(params: any): string {
    if (params.data.serieactiva_finalizada === 'Finalizado') {
      return '<i class="material-icons" title="Finalizado"  style="width: 24px; height: 24px; margin-top: 7%; color: green; border-radius: 50%;">done</i>';
    }
    return '<i class="material-icons" title="Sin Finalizar"  style="width: 24px; height: 24px; margin-top: 7%; color: red; border-radius: 50%;">close</i>';
  }

  getHtmlestadopreparacion(params: any): string {
    if (params.data.serieactiva_novalido == 't') {
      return '<i class="material-icons" title="Devuelto"  style="width: 24px; height: 24px; margin-top: 7%;  color:red; border-radius: 50%;">cancel</i>';
    }
    if (params.data.estado_preparacion == 'f') {
      return '<i class="material-icons" title="Pendiente"  style="width: 24px; height: 24px; margin-top: 7%;  color:yellow; border-radius: 50%;">pending</i>';
    }
    return '<i class="material-icons" title="Listo"  style="width: 24px; height: 24px; margin-top: 7%; color:green; border-radius: 50%;">done</i>';
  }

  getHtmlEtadoInventario(params: any): string {
    if (params.data.estado_inventario == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #ff0000; border-radius: 50%;"></i>';
    }
    return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #008001; border-radius: 50%;"></i>';
  }

  getHtmlEstadoDevolucion(params: any): string {
    if (params.data.serieactiva_novalido === 't') {
      return '<i class="material-icons" title="Devuelto"  style="width: 24px; height: 24px; margin-top: 7%; color: green; border-radius: 50%;">reply</i>';
    }
    return '';
  }

  copy_scroll() {
    let copyscroll = setInterval(() => {
      const headers = document.querySelectorAll<HTMLElement>(
        '.asignacionSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll'
      );
      if (headers.length > 1) {
        headers[0].remove();
      }
      if (headers.length === 1) {
        const clonedHeader = headers[0].cloneNode(true) as HTMLElement;
        clonedHeader.classList.add('sticky-scroll'); // Agregar la clase para fijar el elemento al hacer scroll
        const rootWrapper = document.querySelector<HTMLElement>(
          '.asignacionSeriado .ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height'
        );
        if (rootWrapper === null) {
          return;
        }
        rootWrapper.prepend(clonedHeader);

        // Sincronizar el scroll horizontal entre el header clonado y el original
        const scrollViewports = document.querySelectorAll<HTMLElement>(
          '.asignacionSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
        );
        scrollViewports[0].addEventListener('scroll', function() {
          scrollViewports[1].scrollLeft = scrollViewports[0].scrollLeft;
        });
        scrollViewports[1].addEventListener('scroll', function() {
          scrollViewports[0].scrollLeft = scrollViewports[1].scrollLeft;
        });
      }
      // Sincronizar los espaciadores
      const rightSpacers = document.querySelectorAll<HTMLElement>(
        '.asignacionSeriado .ag-root-wrapper-body .ag-horizontal-right-spacer'
      );
      rightSpacers[0].style.width = rightSpacers[1].style.width;
      rightSpacers[0].style.minWidth = rightSpacers[1].style.minWidth;
      rightSpacers[0].style.maxWidth = rightSpacers[1].style.maxWidth;

      const scrollContainer = document.querySelectorAll<HTMLElement>(
        '.asignacionSeriado .ag-root-wrapper-body .ag-body-horizontal-scroll-container'
      );
      scrollContainer[0].style.width = scrollContainer[1].style.width;
      scrollContainer[0].style.minWidth = scrollContainer[1].style.minWidth;
      scrollContainer[0].style.maxWidth = scrollContainer[1].style.maxWidth;

      clearInterval(copyscroll);
    }, 3000);
  }

  namesEq: any = [];
  namesEqALL: any = [];
  dataRepeated: Array<any> = [];
  dataRepeatedALL: Array<any> = [];
  async preLoadExcel() {
    this.dataRepeated = [];
    this.dataRepeatedALL = [];
    let datos = await this.getAsignacionSeriado();
    this.namesEq = datos.filter(
      (e: any) => e.serieactiva_finalizada === 'Sin Finalizar'
    );
    this.namesEqALL = datos;
    //.map((e: any) => {
    //  return {
    //    serienumero: e.serienumero,
    //  };
    //});
    this.namesEqALL.forEach((dato: any) => {
      this.dataRepeatedALL.push({
        Serie: dato.serienumero,
        IMEI: dato.serieimei,
        SIM: dato.simserienumero,
        'Tipo Equipo ERP': dato.tipoeq,
        'Fecha Preparación': dato.serieactivafecha_alta,
        Modalidad: dato.modalidad,
        'Producto Comercial': dato.producto_comercial,
        Plataforma: dato.plataforma,
        'Fecha Plataforma': dato.serieactivaplata_fecha,
        'Registro en Plataforma': dato.serieactivaplata_ingresada
          .replace('N', 'No')
          .replace('S', 'Si'),
        'ID Plataforma': dato.serieactivaid_dispositivo,
        AVL: dato.serieactivaavl,
        Observacion: dato.serieactivaobs,
        'Cambio Bateria': '',
        'Fecha Cambio Bateria': dato.fecha_bateria,
        'Registro Validado': dato.estado_preparacion == 't' ? 'Si' : 'No',
      });
    });

    this.namesEq.forEach((dato: any) => {
      if (dato.serieactiva_novalido == 'f') {
        this.dataRepeated.push({
          Serie: dato.serienumero,
          IMEI: dato.serieimei,
          SIM: dato.simserienumero,
          'Tipo Equipo ERP': dato.tipoeq,
          'Fecha Preparación': dato.serieactivafecha_alta,
          Modalidad: dato.modalidad,
          'Producto Comercial': dato.producto_comercial,
          Plataforma: dato.plataforma,
          'Fecha Plataforma': dato.serieactivaplata_fecha,
          'Registro en Plataforma': dato.serieactivaplata_ingresada
            .replace('N', 'No')
            .replace('S', 'Si'),
          'ID Plataforma': dato.serieactivaid_dispositivo,
          AVL: dato.serieactivaavl,
          Observacion: dato.serieactivaobs,
          'Cambio Bateria': '',
          'Fecha Cambio Bateria': dato.fecha_bateria,
          'Registro Validado': 'No',
        });
      }
    });
  }

  async descargarPlantilla(tipo: any = 'PENDIENTES') {
    this.loadingService.showLoading(undefined, 'check_tipoproveedor_oc');
    let headers = {};
    headers = {
      header: [
        'Serie',
        'IMEI',
        'SIM',
        'Tipo Equipo ERP',
        'Fecha Preparación',
        'Modalidad',
        'Producto Comercial',
        'Plataforma',
        'Fecha Plataforma',
        'Registro en Plataforma',
        'ID Plataforma',
        'AVL',
        'Cambio Bateria',
        'Fecha Cambio Bateria',
        'Registro Validado',
      ],
    };
    let ws: any = null;
    let name: string = '';
    if (tipo == 'PENDIENTES') {
      let lista: any = [];
      this.ordesList.forEach((dato: any) => {
        if (dato.serieactiva_novalido == 'f') {
          lista.push({
            Serie: dato.serienumero,
            IMEI: dato.serieimei,
            SIM: dato.simserienumero,
            'Tipo Equipo ERP': dato.tipoeq,
            'Fecha Preparación': dato.serieactivafecha_alta,
            Modalidad: dato.modalidad,
            'Producto Comercial': dato.producto_comercial,
            Plataforma: dato.plataforma,
            'Fecha Plataforma': dato.serieactivaplata_fecha,
            'Registro en Plataforma': dato.serieactivaplata_ingresada
              .replace('N', 'No')
              .replace('S', 'Si'),
            'ID Plataforma': dato.serieactivaid_dispositivo,
            AVL: dato.serieactivaavl,
            Observacion: dato.serieactivaobs,
            'Cambio Bateria': '',
            'Fecha Cambio Bateria': dato.fecha_bateria,
          });
        }
      });

      ws = utils.json_to_sheet(lista, headers);
      name = 'pendientes';
    } else {
      ws = utils.json_to_sheet(this.dataRepeatedALL, headers);
      name = 'todo';
    }
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    //writeFileXLSX(wb, 'SeriesOC.xlsx');
    writeFileXLSX(
      wb,
      `Plantilla_Preparacion_EQ_${this.regSeleccionado.asignumero}_${name}.xlsx`
    );
    this.$snotify.success('Plantilla Excel descargada con éxito');
    this.loadingService.hideLoading('check_tipoproveedor_oc');
  }

  quitarRegistro() {
    let input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input) {
      input.value = ''; // Restablecer el valor del input
    }
    this.itemsDelExcel = [];
    this.archivoB64 = '';
    this.fileName = '';
    this.errorArchivoModal = false;
    this.errorMessage = '';
    this.errorArchivo = true;
  }

  errorMessage: any = '';
  prepare_file_upload() {
    const input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input != null && input.files) {
      this.fileName = input.files[0].name;
      const file = input.files[0];
      const reader = new FileReader();
      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        this.archivoB64 = rawImg;
      };
      reader.readAsDataURL(file);
      readXlsFile(input.files[0])
        .then((rows: any) => {
          let datos: any = [...rows];
          if (datos.length == 0) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Serie"'
            );
            this.errorArchivo = true;
            return;
          }
          let firtsRow: any = datos[0] || '';
          if (firtsRow[0].toLowerCase() != 'serie') {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Serie"'
            );
            this.errorArchivo = true;
            return;
          }

          //validos los nombres de las columnas
          if (
            datos[0][0].toLowerCase() != 'serie' ||
            datos[0][1].toLowerCase() != 'imei' ||
            datos[0][2].toLowerCase() != 'sim' ||
            datos[0][3].toLowerCase() != 'tipo equipo erp' ||
            datos[0][4].toLowerCase() != 'fecha preparación' ||
            datos[0][5].toLowerCase() != 'modalidad' ||
            datos[0][6].toLowerCase() != 'producto comercial' ||
            datos[0][7].toLowerCase() != 'plataforma' ||
            datos[0][8].toLowerCase() != 'fecha plataforma' ||
            datos[0][9].toLowerCase() != 'registro en plataforma' ||
            datos[0][10].toLowerCase() != 'id plataforma' ||
            datos[0][11].toLowerCase() != 'avl' ||
            datos[0][12].toLowerCase() != 'cambio bateria' ||
            datos[0][13].toLowerCase() != 'fecha cambio bateria' ||
            datos[0][14].toLowerCase() != 'registro validado' ||
            datos[0][15].toLowerCase() != 'observacion'
          ) {
            this.$snotify.warning(
              'Las columnas no coinciden con el formato esperado. Por favor, descargue la plantilla y complete los datos.'
            );
            this.errorArchivo = true;
            return;
          }

          datos = datos.splice(1);
          if (!datos[0]) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "Serie"'
            );
            this.errorArchivo = true;
            return;
          }

          let hasError = false;
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

          this.itemsDelExcel = datos.map((item: any, index: number) => {
            // Validación de las columnas 1, 3 y 7
            let required_fecha_bateria = false;
            let required_fecha_plataforma = false;

            if (item[12] !== null && item[12].toLowerCase() == 'si') {
              required_fecha_bateria = true;
            }
            if (item[9] !== null && item[9].toLowerCase() == 'si') {
              required_fecha_plataforma = true;
            }

            const cambioBateriaValido = ['si', 'no', ''].includes(
              item[12] ? item[12].toLowerCase() : ''
            );
            const registroPlataformaValido = ['si', 'no', ''].includes(
              item[9] ? item[9].toLowerCase() : ''
            );
            const registroValidadoValido = ['si', 'no', ''].includes(
              item[14] ? item[14].toLowerCase() : ''
            );
            // Validación de las columnas 2 y 4 (fechas)
            // Nuevas validaciones para las columnas 5 y 6 (no pueden estar vacías)
            //const idPlataformaValido = item[5] !== '' && item[5] != null;
            //const simValido = item[6] !== '' && item[6] != null;

            let fechaCambio = item[13]; // Suponiendo que item[2] es el número serial de Excel para la fecha
            let fechaPlataforma = item[8];

            let fechaCambioValido;
            let fechaPlataformaValido;

            // Verificar si es un número y convertirlo a fecha
            if (fechaCambio) {
              if (typeof fechaCambio === 'string') {
                if (/^\d{4}-\d{2}-\d{2}$/.test(fechaCambio)) {
                  fechaCambioValido = true;
                }
                if (/^\d{2}-\d{2}-\d{4}$/.test(fechaCambio)) {
                  fechaCambioValido = true;
                  fechaCambio = fechaCambio
                    .split('-')
                    .reverse()
                    .join('-');
                }
                if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(fechaCambio)) {
                  fechaCambioValido = true;
                  fechaCambio =
                    fechaCambio
                      .split(' ')[0]
                      .split('-')
                      .reverse()
                      .join('-') +
                    ' ' +
                    fechaCambio.split(' ')[1];
                }
                if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(fechaCambio)) {
                  fechaCambioValido = true;
                }
              } else {
                const fechaCambioDate = this.excelSerialToDate(fechaCambio);
                if (fechaCambioDate === null) {
                  fechaCambioValido = false;
                } else {
                  item[13] = this.formatDate(fechaCambioDate); // Convertir la fecha a formato yyyy-mm-dd
                  fechaCambioValido = dateRegex.test(item[13]);
                }
              }
            } else {
              // Si no es un número, se maneja como un caso de error o como consideres apropiado
              fechaCambioValido = false;
            }
            // Verificar si es un número y convertirlo a fecha
            if (fechaPlataforma) {
              console.log(fechaPlataforma);
              if (typeof fechaPlataforma === 'string') {
                if (/^\d{4}-\d{2}-\d{2}$/.test(fechaPlataforma)) {
                  fechaPlataformaValido = true;
                }
                if (/^\d{2}-\d{2}-\d{4}$/.test(fechaPlataforma)) {
                  fechaPlataformaValido = true;
                  fechaPlataforma = fechaPlataforma
                    .split('-')
                    .reverse()
                    .join('-');
                }
                if (
                  /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(fechaPlataforma)
                ) {
                  fechaPlataformaValido = true;
                  fechaPlataforma =
                    fechaPlataforma
                      .split(' ')[0]
                      .split('-')
                      .reverse()
                      .join('-') +
                    ' ' +
                    fechaPlataforma.split(' ')[1];
                }
                if (
                  /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(fechaPlataforma)
                ) {
                  fechaPlataformaValido = true;
                }
              } else {
                console.log(fechaPlataforma);
                const fechaplataformaDate = this.excelSerialToDate(
                  fechaPlataforma
                );
                console.log(fechaplataformaDate);
                if (fechaplataformaDate === null) {
                  fechaPlataformaValido = false;
                } else {
                  item[8] = this.formatDate(fechaplataformaDate); // Convertir la fecha a formato yyyy-mm-dd
                  fechaPlataformaValido = dateRegex.test(item[8]);
                }
              }
            } else {
              // Si no es un número, se maneja como un caso de error o como consideres apropiado
              fechaPlataformaValido = false;
            }

            if (!cambioBateriaValido) {
              this.errorMessage += `- Fila ${index +
                2}: El valor de Cambio de Bateria no es válido (debe ser "SI", "NO" o estar vacío).<br>`;
              hasError = true;
            }
            if (!registroPlataformaValido) {
              this.errorMessage += `- Fila ${index +
                2}: El valor de la columna Registro Plataforma no es válido (debe ser "SI", "NO" o estar vacío).<br>`;
              hasError = true;
            }
            if (!registroValidadoValido) {
              this.errorMessage += `- Fila ${index +
                2}: El valor de la columna Registro Validado no es válido (debe ser "SI", "NO" o estar vacío).<br>`;
              hasError = true;
            }
            if (!fechaCambioValido && required_fecha_bateria) {
              this.errorMessage += `- Fila ${index +
                2}: El valor de la columna Fecha de Cambio de batería no es una fecha válida o no está en el formato correcto (yyyy-mm-dd).<br>`;
              hasError = true;
              console.log(fechaCambioValido);
            }
            if (!fechaPlataformaValido && required_fecha_plataforma) {
              this.errorMessage += `- Fila ${index +
                2}: El valor de la columna Fecha de Registro en Plataforma no es una fecha válida o no está en el formato correcto (yyyy-mm-dd).<br>`;
              hasError = true;
            }
            /*if (!idPlataformaValido) {
              this.errorMessage += `- Fila ${index +
                2}: La columna Id Plataforma no puede estar vacía.<br>`;
              hasError = true;
            }
            if (!simValido) {
              this.errorMessage += `- Fila ${index +
                2}: La columna SIM no puede estar vacía.<br>`;
              hasError = true;
            }*/

            if (hasError) {
              return null;
            }

            let sim1 = item[2];
            if (sim1 !== null) {
              sim1.toString();
            }
            let imei1 = item[1];
            if (imei1 !== null) {
              imei1.toString();
            }
            return {
              serie: item[0] || '',
              imei: imei1 || '',
              sim: sim1 || '',
              tipo_eq_erp: item[3] || '',
              fecha_preparacion: item[4] || '',
              modalidad: item[5] || '',
              producto_comercial: item[6] || '',
              plataforma: item[7] || '',
              fechaPlataforma: fechaPlataforma || '',
              registroPlataforma: item[9] || '',
              idPlataforma: item[10] || '',
              avl: item[11] || '',
              cambioBateria: item[12] || '',
              fechaCambio: fechaCambio || '',
              registroValidado: item[14] || '',
              observacion: item[15] || '',
              idUser: JSON.parse(window.localStorage.user).id,
              asignumero: this.regSeleccionado.asignumero,
            };
          });

          if (hasError) {
            this.errorArchivo = true;
            this.itemsDelExcel = [];
            this.errorArchivoModal = true;
          } else {
            // Filtrar los elementos nulos (en caso de que haya habido errores de validación)
            this.itemsDelExcel = this.itemsDelExcel.filter(
              item => item !== null
            );
            this.errorArchivo = false;
            this.errorArchivoModal = false;
          }
        })
        .catch((e: any) => {
          console.log(e);
          this.itemsDelExcel = [];
          this.errorMessage = `Ocurrió un error al leer el archivo: ${e.message}<br>`;
          this.errorArchivo = true;
          this.errorArchivoModal = true;
        });
    }
  }

  cargar() {
    this.loadingService.showLoading();
    const body = {
      lista: this.itemsDelExcel,
      asignumero: this.regSeleccionado.asignumero,
    };
    let self = this;
    return fetchMS(body, 'cargarSeriado')
      .then(resp => {
        if (resp.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.itemsDelExcel = [];
          this.archivoB64 = '';
          this.fileName = '';
          this.errorArchivoModal = false;
          this.errorMessage = '';
          this.errorArchivo = true;
        } else {
          self.errorMessage = resp.data.MENSAJE_RESPUESTA;
          self.errorArchivoModal = true;
          self.loadingService.hideLoading();
        }
        let input = document.getElementById(
          'archivoExcel'
        ) as HTMLInputElement | null;
        if (input) {
          input.value = ''; // Restablecer el valor del input
        }
        self.loadingService.hideLoading();
      })
      .catch(error => {
        if (error.message == 'Network Error') {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        } else if (error.response.status != 404) {
          self.$snotify.error('Ha ocurrido un error al ingresar el equipo', {
            timeout: 3000,
          });
        }
        self.loadingService.hideLoading();
      })
      .finally(() => {
        self.loadingService.hideLoading();
        self.reloadGrid();
      });
  }

  async reloadGrid() {
    this.ordesList = (await this.getAsignacionSeriado()) || [];
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }
  // Función para convertir el número de Excel a una fecha de JavaScript
  excelSerialToDate(serial: any): Date {
    if (serial == null) {
      return null;
    }
    // Excel serial date offset
    if (typeof serial == 'object') {
      //window.serial = serial;
      const offset = serial.getTimezoneOffset() * 60000;
      const correctDate = new Date(serial.getTime() + offset);
      return correctDate;
    }

    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);

    // Compensate for the timezone offset
    const offset = date_info.getTimezoneOffset() * 60000;
    const correctDate = new Date(date_info.getTime() + offset);

    return correctDate;
  }

  // Función para formatear una fecha de JavaScript en el formato yyyy-mm-dd
  formatDate(date: string | number | Date) {
    const d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
  }
}
